import React from 'react';
const Dashboard = React.lazy(() => import('./views/Dashboard/dashboard'));
const Withdraws = React.lazy(() => import('./views/Withdraws/WithdrawsPage'))
const Customers = React.lazy(() => import('./views/Customers/index'));
// Product
const ListProduct = React.lazy(() => import('./views/Products/index'));
// const DetailProduct = React.lazy(() => import('./views/Products/view'));
// const CreateProduct = React.lazy(() => import('./views/Products/form'));
// const EditProduct = React.lazy(() => import('./views/Products/edit'));
const ProductVariantRefactor = React.lazy(() => import('./views/Products/refactor/form'));
const DetailProductRefactor = React.lazy(() => import('./views/Products/refactor/viewDetail'));
const EditProductRefactor = React.lazy(() => import('./views/Products/refactor/edit'));
// Variant
const ProductVariant = React.lazy(() => import('./views/Variants/index'));
const AddAttribute = React.lazy(() => import('./views/Variants/create'));
const AddOption = React.lazy(() => import('./views/Variants/createOption'));
const ViewOption = React.lazy(() => import('./views/Variants/viewSub'));
// Category
const ListCategory = React.lazy(() => import('./views/Category/index'));
const AddCategory = React.lazy(() => import('./views/Category/create'));
const ViewCategory = React.lazy(() => import('./views/Category/view'));
const AddSubCategory = React.lazy(() => import('./views/Category/createSub'));
const ViewSubCategory = React.lazy(() => import('./views/Category/viewSub'));
// Order
const ListOrder = React.lazy(() => import('./views/Order/Process/index'));
const ListOrderNew = React.lazy(() => import('./views/Order/New/index'));
const ListOrderReady = React.lazy(() => import('./views/Order/Ready/index'));
const ListOrderDelivery = React.lazy(() => import('./views/Order/Delivery/index'));
const ListOrderWaitingConfirm = React.lazy(() => import('./views/Order/Waiting_Confirm/index'));
const ListOrderComplained = React.lazy(() => import('./views/Order/Complained/index'));
const ListOrderPaid = React.lazy(() => import('./views/Order/Completed/index'));
const ListOrderCanceled = React.lazy(() => import('./views/Order/Canceled/index'));
const DetailOrderByOrderNumber = React.lazy(() => import('./views/Order/detailByOrderNumber'));
const DetailOrderById = React.lazy(() => import('./views/Order/detail'));
const ListPending = React.lazy(() => import('./views/Order/Pending/index'));
// Brand
const ListBrand = React.lazy(() => import('./views/Brands/index'));
const DetailBrand = React.lazy(() => import('./views/Brands/view'));
const CreateBrand = React.lazy(() => import('./views/Brands/create'));
const EditBrand = React.lazy(() => import('./views/Brands/edit'));

const OrderReport = React.lazy(() => import('./views/Report/Order/index'));
const TransactionReport = React.lazy(() => import('./views/Report/Transaction/index'));
const Bank = React.lazy(() => import('./views/Finance/Bank/bank.page'));
const Withdraw = React.lazy(() => import('./views/Finance/Withdraw/withdraw.page'));
const WithdrawRequest = React.lazy(() => import('./views/Finance/Withdraw/withdraw.request.page'));
const Profile = React.lazy(() => import('./views/Setting/Profile/ProfilePage'));
const ChangePassword = React.lazy(() => import('./views/Setting/Profile/ChangePasswordPage'));
const ChatBot = React.lazy(() => import('./views/Setting/Chatbot/ChatbotPage'));
// const AffiliateFee = React.lazy(() => import('./views/Setting/AdminFee/AdminFeePage'));
const Payout = React.lazy(() => import('./views/Setting/Payout/PayoutPage'));
const Delivery = React.lazy(() => import('./views/Setting/Delivery/DeliverySettingPage'));
const BusinessDaySetting = React.lazy(() => import('./views/Setting/BusinessDays'));

// Settings
const Custom = React.lazy(() => import('./views/Custom/index'));

// Reseller
const Reseller = React.lazy(() => import('./views/Reseller/index'));
const ViewReseller = React.lazy(() => import('./views/Reseller/view'));
const CreateReseller = React.lazy(() => import('./views/Reseller/create'));
const ViewResellerOrder = React.lazy(() => import('./views/Reseller/viewResellerOrder'));
// User
const Users = React.lazy(() => import('./views/Users/index'));
const ViewUser = React.lazy(() => import('./views/Users/view'));
const CreateUser = React.lazy(() => import('./views/Users/create'));
const Assign = React.lazy(() => import('./views/Users/assign'));
const AssignMerchant = React.lazy(() => import('./views/Users/assignMerchant'));
const Password = React.lazy(() => import('./views/Users/password'));
// Merchant
const Merchant = React.lazy(() => import('./views/Merchant/index'));
const ViewMerchant = React.lazy(() => import('./views/Merchant/view'));
const CreateMerchant = React.lazy(() => import('./views/Merchant/create'));
// Services Schedule
const ServicesSchedule = React.lazy(() => import('./views/ServicesSchedule/index'));
const CreateServicesSchedule = React.lazy(() => import('./views/ServicesSchedule/form'));
const EditServicesSchedule = React.lazy(() => import('./views/ServicesSchedule/edit'));
// Services Provider / Provider
const ProviderList = React.lazy(() => import('./views/Provider/index'));
const ProviderDetail = React.lazy(() => import('./views/Provider/view'));
const ProviderCreate = React.lazy(() => import('./views/Provider/form'));
const ProviderUpdate = React.lazy(() => import('./views/Provider/edit'));
// Order Service
const ListOrderService = React.lazy(() => import('./views/OrderService/Process/index'));
const ListOrderServicePending = React.lazy(() => import('./views/OrderService/Pending/index'));
const ListOrderServiceNew = React.lazy(() => import('./views/OrderService/New/index'));
const ListOrderServicePaid = React.lazy(() => import('./views/OrderService/Completed/index'));
const ListOrderServiceCanceled = React.lazy(() => import('./views/OrderService/Canceled/index'));
const DetailOrderServiceByOrderNumber = React.lazy(
  () => import('./views/OrderService/detailByOrderNumber'),
);
const DetailOrderServiceById = React.lazy(() => import('./views/OrderService/detail'));
const ChatHistory = React.lazy(() => import('./views/ChatHistory/chat-history'));
const FeatureNotReadyYet = React.lazy(() => import('./views/ChatHistory/feature-not-ready-yet'));
//notifications
const Notifications = React.lazy(() => import('./views/Notifications/index'));
//Promo
const PromoList = React.lazy(() => import('./views/Promo/index'));
const CreatePromoPage = React.lazy(() => import('./views/Promo/create/index'));
const PromoDetails = React.lazy(() => import('./views/Promo/detail/index'));

const routes = [
  { path: '/', name: 'Beranda', element: Dashboard },
  { path: '/customers', name: 'Pelanggan', element: Customers },
  { path: '/products', name: 'Produk', element: ListProduct },
  { path: '/products/create/:type', name: 'Buat Produk', element: ProductVariantRefactor },
  { path: '/products/view/:id', name: 'Detail Produk', element: DetailProductRefactor },
  { path: '/products/:id/edit/:type', name: 'Edit Produk', element: EditProductRefactor },
  { path: '/categories', name: 'Kategori', element: ListCategory },
  { path: '/variants', name: 'Varian Produk', element: ProductVariant },

  {
    path: '/categories/add-category',
    name: 'Tambah Kategori',
    element: AddCategory,
  },
  {
    path: '/categories/view-category',
    name: 'Detail Kategori',
    element: ViewCategory,
  },
  {
    path: '/categories/edit-category',
    name: 'Edit Kategori',
    element: AddCategory,
  },
  {
    path: '/categories/add-sub-categories',
    name: 'Tambah Sub Kategori',
    element: AddSubCategory,
  },
  {
    path: '/categories/view-sub-categories',
    name: 'Detail Sub Kategori',
    element: ViewSubCategory,
  },
  {
    path: '/categories/edit-sub-categories',
    name: 'Edit Sub Kategori',
    element: AddSubCategory,
  },
  { path: '/variants/add-attributes', name: 'Tambah Attribut', element: AddAttribute },
  { path: '/variants/edit-attributes', name: 'Edit Attribut', element: AddAttribute },
  { path: '/variants/add-options', name: 'Tambah Opsi', element: AddOption },
  { path: '/variants/view-options', name: 'Detail Opsi', element: ViewOption },
  { path: '/variants/edit-options', name: 'Edit Opsi', element: AddOption },
  { path: '/orders/new', name: 'Penjualan - Baru', element: ListOrderNew },
  { path: '/orders/pending', name: 'Penjualan - Pending', element: ListPending },
  {
    path: '/orders/process',
    name: 'Penjualan - Diproses',
    element: ListOrder,
  },
  { path: '/orders/ready', name: 'Penjualan - Siap', element: ListOrderReady },
  {
    path: '/orders/delivery',
    name: 'Penjualan - Dikirim',
    element: ListOrderDelivery,
  },
  {
    path: '/orders/complained',
    name: 'Penjualan - komplain',
    element: ListOrderComplained,
  },
  {
    path: '/orders/waiting',
    name: 'Penjualan - Menunggu Konfirmasi',
    element: ListOrderWaitingConfirm,
  },
  {
    path: '/orders/canceled',
    name: 'Penjualan - Batal',
    element: ListOrderCanceled,
  },
  {
    path: '/orders/completed',
    name: 'Penjualan - Berhasil',
    element: ListOrderPaid,
  },
  {
    path: '/orders/:orderNumber',
    name: 'Detail Penjualan',
    element: DetailOrderByOrderNumber,
  },
  {
    path: '/orders/:id/detail',
    name: 'Detail Penjualan',
    element: DetailOrderById,
  },
  { path: '/brands', name: 'Brand', element: ListBrand },
  { path: '/brands/create', name: 'Buat Brand', element: CreateBrand },
  { path: '/brands/:id', name: 'Detail Brand', element: DetailBrand },
  { path: '/brands/:id/edit', name: 'Edit Brand', element: EditBrand },
  { path: '/report/order', name: 'Laporan Penjualan', element: OrderReport },
  { path: '/report/transaction', name: 'Laporan Saldo', element: TransactionReport },
  { path: '/finance/bank', name: 'Daftar Rekening Bank', element: Bank },
  {
    path: '/finance/withdraw',
    name: 'Daftar Permintaan Penarikan',
    element: Withdraw,
  },
  {
    path: '/finance/withdraw/request',
    name: 'Buat Permintaan Penarikan',
    element: WithdrawRequest,
  },
  { path: '/setting/profile', name: 'Pengaturan Profil', element: Profile },
  { path: '/setting/change-password', name: 'Ubah Kata Sandi', element: ChangePassword },
  { path: '/setting/chatbot', name: 'Pengaturan Chat Bot', element: ChatBot },
  // { path: '/setting/affiliate-fee', name: 'Pengaturan Fee Affiliator', element: AffiliateFee },
  { path: '/setting/payout', name: 'Pengaturan Payout', element: Payout },  
  { path: '/setting/delivery', name: 'Pengaturan Pengiriman', element: Delivery },
  { path: '/setting/business-days', name: 'Pengaturan Jam Buka Toko', element: BusinessDaySetting },
  { path: '/Custom', name: 'Custom', element: Custom },
  { path: '/reseller', name: 'Reseller', element: Reseller },
  { path: '/reseller/view', name: 'Detail Reseller', element: ViewReseller },
  { path: '/reseller/create', name: 'Buat Reseller', element: CreateReseller },
  { path: '/reseller/edit-reseller', name: 'Edit Reseller', element: CreateReseller },
  { path: '/reseller/view-orders', name: 'Lihat Orders', element: ViewResellerOrder },
  { path: '/withdraws', name: 'Lihat Pendapatan', element: Withdraws },
  { path: '/users', name: 'Users', element: Users },
  { path: '/users/view', name: 'Detail User', element: ViewUser },
  { path: '/users/create', name: 'Buat User', element: CreateUser },
  { path: '/users/edit-user', name: 'Edit User', element: CreateUser },
  { path: '/users/assign', name: 'Assign Merchant', element: Assign },
  { path: '/users/assign-merchant', name: 'Assign Merchant', element: AssignMerchant },
  { path: '/users/change-password', name: 'Ubah Password', element: Password },
  { path: '/merchant', name: 'Merchant', element: Merchant },
  { path: '/merchant/view', name: 'Detail Merchant', element: ViewMerchant },
  { path: '/merchant/create', name: 'Buat Merchant', element: CreateMerchant },
  {
    path: '/services-schedule/:id/:merchantId/:name',
    name: 'Services Schedule',
    element: ServicesSchedule,
  },
  {
    path: '/services-schedule/:id/:merchantId/:name/create',
    name: 'Create Service Schedule',
    element: CreateServicesSchedule,
  },
  {
    path: '/services-schedule/:id/:merchantId/:name/edit/:idx',
    name: 'Edit Service Schedule',
    element: EditServicesSchedule,
  },
  { path: '/merchant/edit-merchant', name: 'Edit Merchant', element: CreateMerchant },
  { path: '/provider', name: 'Provider', element: ProviderList },
  { path: '/provider/:id', name: 'Detail Provider', element: ProviderDetail },
  { path: '/provider/create', name: 'Buat Provider', element: ProviderCreate },
  { path: '/provider/edit/:id', name: 'Edit Provider', element: ProviderUpdate },
  {
    path: '/order-service/pending',
    name: 'Penjualan Jasa - Pending',
    element: ListOrderServicePending,
  },
  { path: '/order-service/new', name: 'Penjualan Jasa - Baru', element: ListOrderServiceNew },
  { path: '/order-service/process', name: 'Penjualan Jasa - Diproses', element: ListOrderService },
  {
    path: '/order-service/canceled',
    name: 'Penjualan Jasa - Batal',
    element: ListOrderServiceCanceled,
  },
  {
    path: '/order-service/completed',
    name: 'Penjualan Jasa - Berhasil',
    element: ListOrderServicePaid,
  },
  {
    path: '/order-service/:orderNumber',
    name: 'Detail Penjualan Jasa',
    element: DetailOrderServiceByOrderNumber,
  },
  {
    path: '/order-service/:id/detail',
    name: 'Detail Penjualan Jasa',
    element: DetailOrderServiceById,
  },
  { path: '/chat-history', name: 'Riwayat Chat', element: process.env.REACT_APP_HISTORY_CHAT && process.env.REACT_APP_HISTORY_CHAT === 'true' ? ChatHistory : FeatureNotReadyYet },
  { path: '/notifications', name: 'Notifikasi', element: Notifications },
  { path: '/promos', name: 'Pengaturan Promo', element: PromoList },
  { path: '/promos/create', name: 'Buat Promo Baru', element: CreatePromoPage },
  { path: '/promos/:id/detail', name: 'Detail Promo', element: PromoDetails },
  { path: '/promos/:id/edit', name: 'Edit Promo', element: CreatePromoPage },
];

export default routes;
